import { useEffect, useState } from "react";

export function useElementWidth<T extends HTMLElement>(
    ref: React.RefObject<T>
) {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (!ref.current) return;

        const element = ref.current;

        const updateWidth = () => {
            setWidth(element.clientWidth);
        };

        updateWidth();

        const observer = new ResizeObserver(() => {
            updateWidth();
        });

        observer.observe(element);
        window.addEventListener("resize", updateWidth);

        return () => {
            observer.disconnect();
            window.removeEventListener("resize", updateWidth);
        };
    }, [ref]);

    return width;
}
